import { authRoles } from "../../auth/authRoles";
import EditInformasiUmum from "./EditInformasiUmum";

const infoUmumRoutes = [
  {
    path: "/informasi_umum",
    exact: true,
    component: EditInformasiUmum,
    auth: authRoles.all,
  },
];

export default infoUmumRoutes;
